export default "__VITE_ASSET__DPUXkR8Y__"